module.exports = __webpack_public_path__ + "media/images/mailer/cancel-48-primary-f827dc541124bf464e96c97e7a7acbdc.png";